import { Flex } from '@uhg-abyss/web/ui/Flex';
import { Heading } from '@uhg-abyss/web/ui/Heading';
import { PageBody } from '@uhg-abyss/web/ui/PageBody';
import { Text } from '@uhg-abyss/web/ui/Text';

import { GuestSearchBar } from './GuestSearchBar';

export const GuestProviderNameSearchContainer = () => (
  <PageBody>
    <Heading level={1} size="lg" textAlign="center">
      Who are you looking for?
    </Heading>

    <Flex style={{ justifyContent: 'center' }}>
      <Text>Search by provider, provider group, or facility and location.</Text>

      <Flex style={{ marginTop: '21px', width: '75%' }}>
        <GuestSearchBar />
      </Flex>
    </Flex>
  </PageBody>
);
